module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "ownersNotAssignedTeams": {
        "type": "number",
        "isOptional": true
      },
      "quotasForOwners": {
        "type": "boolean",
        "isOptional": true
      },
      "ownersInTable": {
        "type": "boolean",
        "isOptional": true
      },
      "isDealStageView": {
        "type": "boolean",
        "isOptional": true
      },
      "isCompanyCurrency": {
        "type": "boolean",
        "isOptional": true
      },
      "isDefaultForecast": {
        "type": "boolean",
        "isOptional": true
      },
      "pipeline": {
        "type": "string",
        "isOptional": true
      },
      "timePeriod": {
        "type": "string",
        "isOptional": true
      },
      "cadence": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "forecasting-ui",
    "version": "1"
  },
  "RepView": {
    "name": "repview",
    "class": "view",
    "properties": {
      "hasData": "boolean",
      "isDealStageView": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "forecasting-ui",
    "version": "1"
  },
  "forecastingInteraction": {
    "name": "Forecasting Interaction",
    "class": "interaction",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": "string",
        "isOptional": true
      },
      "action": [
        "preview-deal",
        "inline-edit-deal-property",
        "view-deals-in-crm",
        "open-submission-panel",
        "open-submission-panel-by-selecting-deal",
        "close-submission-panel",
        "submit-forecast",
        "submit-forecast-for-all-pipelines",
        "drill-into-team",
        "navigate-by-breadcrumb",
        "open-goals-from-attainment",
        "select-deal-from-deal-table",
        "deselect-deal-from-deal-table",
        "click-submit-forecast-from-deal-table",
        "backfill-category-labels-to-values",
        "open-overview-search",
        "close-overview-search",
        "select-overview-search",
        "override-selected-deal-amount",
        "add-submission-note",
        "switch-forecast-types",
        "switch-tabs",
        "open-deal-sidebar",
        "view-deals-in-crm-from-sidebar",
        "view-goals-in-crm-from-sidebar",
        "view-submission-panel-history",
        "navigate-to-sales-analytics",
        "open-rep-detail-from-submission-panel",
        "view-included-deals-from-submit",
        "view-included-deals-from-history",
        "open-deal-from-included-deals",
        "click-delete-submission",
        "confirm-delete-own-submission",
        "confirm-delete-other-submission",
        "cancel-delete-submission",
        "show-deals-not-saved-alert",
        "create-goal-from-forecast",
        "save-bar-cancel",
        "deal-table-sort",
        "deal-table-edit-columns-open",
        "deal-table-edit-columns-save",
        "start-ui-tour",
        "next-step-ui-tour",
        "cancel-ui-tour",
        "finish-ui-tour",
        "show-deal-stage-forecast-intro-modal",
        "cancel-onboarding",
        "change-categories-onboarding",
        "change-pipeline-onboarding",
        "change-period-onboarding",
        "click-learn-more-onboarding",
        "finish-onboarding",
        "hover-over-categories-onboarding",
        "next-step-onboarding",
        "previous-step-onboarding",
        "start-onboarding",
        "click-create-goal-onboarding",
        "delete-category-onboarding",
        "delete-is-blocked-onboarding",
        "max-categories-onboarding",
        "rename-category-onboarding",
        "disable-automation-onboarding",
        "open-multicurrency-panel",
        "set-preferred-currency",
        "reassign-deals-for-deactivated-user",
        "open-deal-sidebar-from-deal-count",
        "open-goals-sidebar-from-attainment",
        "switch-to-goals-sidebar",
        "switch-to-deals-sidebar",
        "navigate-back-in-submission-history",
        "navigate-forward-in-submission-history",
        "edit-goals-from-forecast",
        "view-report-from-forecast",
        "view-forecast-users-popover",
        "view-currencies-from-panel",
        "dismiss-new-ia-alert",
        "take-new-ia-tour",
        "cancel-new-ia-tour",
        "next-step-new-ia-tour",
        "previous-step-new-ia-tour",
        "finish-new-ia-tour",
        "click-use-default-welcome-modal",
        "click-create-forecast-welcome-modal",
        "start-existing-user-fmo-tour",
        "skip-existing-user-fmo-tour",
        "click-create-forecast-header",
        "click-create-forecast-filter",
        "switch-forecast-type",
        "forecast-type-permission-error",
        "fmo-tour-dropdown-step",
        "fmo-tour-create-forecast-step",
        "onboarding-forecast-category-tab",
        "onboarding-analyze-tab",
        "onboarding-forecast-submission",
        "name-forecast-type",
        "select-date-type",
        "select-amount-type",
        "create-forecast-type",
        "create-forecast-wizard-step-1",
        "close-wizard-and-skip-goal-creation",
        "close-wizard-and-create-goal",
        "cancel-create-forecast-type-wizard",
        "complete-create-forecast-type-wizard",
        "dismiss-set-currency-alert",
        "manage-forecasts",
        "open-edit-default-columns-modal",
        "track-save-default-columns",
        "dismiss-ai-forecasting-v2-alert",
        "click-edit-default-columns-link"
      ],
      "isDealStageView": {
        "type": "boolean",
        "isOptional": true
      },
      "teamId": {
        "type": "number",
        "isOptional": true
      },
      "propertyKeys": {
        "type": "array",
        "isOptional": true
      },
      "currentStep": {
        "type": "string",
        "isOptional": true
      },
      "currencyCode": {
        "type": "string",
        "isOptional": true
      },
      "isCompanyCurrency": {
        "type": "boolean",
        "isOptional": true
      },
      "isDefaultForecast": {
        "type": "boolean",
        "isOptional": true
      },
      "selectedDealCount": {
        "type": "number",
        "isOptional": true
      },
      "dateProperty": {
        "type": "string",
        "isOptional": true
      },
      "amountProperty": {
        "type": "string",
        "isOptional": true
      },
      "duplicateOfDefault": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "forecasting-ui",
    "version": "1"
  },
  "useFilters": {
    "name": "Use filters",
    "class": "interaction",
    "properties": {
      "pipeline": {
        "type": "string",
        "isOptional": true
      },
      "pipelines": {
        "type": "array",
        "isOptional": true
      },
      "timePeriod": {
        "type": "string",
        "isOptional": true
      },
      "team": {
        "type": "array",
        "isOptional": true
      },
      "dealGrouping": {
        "type": "array",
        "isOptional": true
      },
      "isDefaultForecast": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string"
      }
    },
    "namespace": "forecasting-ui",
    "version": "1"
  },
  "analyzeInteraction": {
    "name": "Analyze Interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "set-pipeline-filter",
        "click-analyze-kb-link",
        "click-analyze-opt-in",
        "click-analyze-opt-in-confirm"
      ],
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "pipeline": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "forecasting-ui",
    "version": "1"
  },
  "aiButtonInteraction": {
    "name": "aiButtonInteraction",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string"
      },
      "featureId": {
        "type": "string",
        "isOptional": true
      },
      "featureCategoryId": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "copilotActionButtonInteraction": {
    "name": "copilotActionButtonInteraction",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string"
      },
      "prompt": {
        "type": "string",
        "isOptional": true
      },
      "hasPrefillValues": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "copyMessageInteraction": {
    "name": "copyMessageInteraction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "prompt_copied"
        ]
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  },
  "feedbackInteraction": {
    "name": "inlineFeedbackInteraction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "prompt_upvoted",
          "prompt_upvote_removed",
          "prompt_downvoted",
          "prompt_downvote_removed"
        ]
      },
      "screen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ai-components-ui-library",
    "version": "1"
  }
};